import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { BimContractSubObjectUpdateInput } from 'gql/graphql';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { bimUpdateWorkOrderChangeSubObjectGql } from '../bimWorkOrderChangeStructureQueries';

const requestId = 'bimUpdateWorkOrderChangeSubObject';

export const useBimUpdateWorkOrderChangeSubObject = (workOrderChangeId?: number, onSuccess?: () => void) => {
    const dispatch = useDispatch();

    const [bimUpdateWorkOrderSubObjectReset] = useResetStoreData({ requestId });

    const onSuccessLocal = useCallback(() => {
        bimUpdateWorkOrderSubObjectReset(undefined);
        onSuccess?.();
    }, [bimUpdateWorkOrderSubObjectReset, onSuccess]);

    const [
        bimUpdateWorkOrderSubObjectData,
        bimUpdateWorkOrderSubObjectStatus,
        bimUpdateWorkOrderSubObjectError,
        bimUpdateWorkOrderSubObjectRequest,
    ] = useRequest({
        requestId,
        query: bimUpdateWorkOrderChangeSubObjectGql,
        withEffect: false,
        dependenciesUpdater: onSuccessLocal,
    });

    const bimUpdateWorkOrderSubObjectChangeMakeRequest = useCallback(
        (input: BimContractSubObjectUpdateInput) => {
            dispatch(bimUpdateWorkOrderSubObjectRequest({ workOrderChangeId, input }));
        },
        [bimUpdateWorkOrderSubObjectRequest, dispatch, workOrderChangeId],
    );

    useEffect(() => {
        bimUpdateWorkOrderSubObjectReset(undefined);
    }, [bimUpdateWorkOrderSubObjectReset]);

    return {
        bimUpdateWorkOrderSubObjectData,
        bimUpdateWorkOrderSubObjectStatus,
        bimUpdateWorkOrderSubObjectError,
        bimUpdateWorkOrderSubObjectChangeMakeRequest,
    };
};
